exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hs_layout {\n  height: 100%;\n  position: relative;\n}\n.section-wrapper {\n  -webkit-transition: all 1.2s ease-in-out;\n  -moz-transition: all 1.2s ease-in-out;\n  -o-transition: all 1.2s ease-in-out;\n  transition: all 1.2s ease-in-out;\n}\n.section-wrapper,\n.section-wrapper-current {\n  height: 100%;\n}\n.section-go {\n  -webkit-transition: all 0.2s ease-out;\n  -moz-transition: all 0.2s ease-out;\n  -o-transition: all 0.2s ease-out;\n  transition: all 0.2s ease-out;\n  z-index: 100;\n  cursor: pointer;\n  position: fixed;\n  top: 45%;\n  color: #fff;\n  display: inline-block;\n  background-color: rgba(20,20,20,0.2);\n  padding: 20px 15px;\n  border-radius: 50%;\n}\n.section-go-left {\n  left: 20px;\n}\n.section-go-right {\n  right: 20px;\n}\n.section-go i {\n  font-size: 30px;\n}\n.section-go:hover {\n  background-color: rgba(20,20,20,0.4);\n}\n@media (max-width: $minWidth) {\n  .section-go-left {\n    display: none;\n  }\n  .section-go-right {\n    display: none;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?paths=gui/css!./ui/c/layout/hsLayout/page.styl
// module id = 857
// module chunks = 0